import { render, staticRenderFns } from "./JobCardHealthcare.vue?vue&type=template&id=0f2df99c&scoped=true&"
import script from "./JobCardHealthcare.vue?vue&type=script&lang=js&"
export * from "./JobCardHealthcare.vue?vue&type=script&lang=js&"
import style0 from "./JobCardHealthcare.vue?vue&type=style&index=0&id=0f2df99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2df99c",
  null
  
)

export default component.exports